const KNOWN_MEDIA_HOST = /(^|\.)cloudfront\.net$|(^|\.)s3\.amazonaws\.com$/i;
const CORS_MEDIA = /\.(mp4|webm|mp3|aac|ogg|vtt|srt)(\?|#|$)/i;

function isKnownMediaHost(url) {
  try {
    return KNOWN_MEDIA_HOST.test(new URL(url).hostname);
  } catch (_error) {
    return false;
  }
}

async function fetchMediaForCache(url) {
  if (CORS_MEDIA.test(url)) {
    const response = await fetch(url, { mode: "cors" });
    return response.ok;
  }

  try {
    const response = await fetch(url, { mode: "cors" });
    if (response.ok) return true;
  } catch (_error) {
    // Images still render from an opaque response.
  }

  const response = await fetch(url, { mode: "no-cors" });
  return response.type === "opaque" || response.ok;
}

export function collectContentMediaUrls(node, urls = []) {
  if (!node || typeof node !== "object") return urls;
  const isMedia = node.type === "image" || node.type === "video" || node.type === "audio";
  if (isMedia && typeof node.url === "string" && node.url.startsWith("http")) {
    urls.push(node.url);
  }
  if (!Array.isArray(node.content)) return urls;
  node.content.forEach((child) => collectContentMediaUrls(child, urls));
  return urls;
}

export async function warmDocumentMediaCache(mediaContext, contentUrls = []) {
  if (!mediaContext) return;
  if (!navigator.serviceWorker?.controller) return false;
  if (typeof navigator !== "undefined" && navigator.onLine === false) return;

  const urls = [
    ...(mediaContext.images || []),
    ...(mediaContext.videos || []),
    ...(mediaContext.audios || []),
    ...(mediaContext.captions || []),
  ]
    .map((asset) => asset?.distribution_url)
    .filter(Boolean)
    .concat(contentUrls || []);

  const uniqueUrls = [...new Set(urls)].filter(isKnownMediaHost);
  if (uniqueUrls.length === 0) return true;

  const results = await Promise.all(
    uniqueUrls.map(async (url) => {
      try {
        return await fetchMediaForCache(url);
      } catch (error) {
        console.warn("[DocumentMediaCache] warm failed", url, error);
        return false;
      }
    }),
  );
  return results.every(Boolean);
}
